import Ably from "ably/promises";
import { API_ABLY_KEY } from "../../../common/constants";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkUserAccess, sendVerificationMessage, updateProfileDetails } from "../../../redux/actions/authentication";
import { toast } from "react-toastify";
import CountryCode from "../../LandingPage/CountryCode";
import { SET_MOBILE_NUMBER } from "../../../redux/actions/types";
import { useSearchParams } from "react-router-dom";
var client, channel;

var client, channel;
const TechnicalFailure = ({
  selectedCountry,
  setSelectedCountry,
  phoneNumber,
  setPhoneNumber,
  setRenderComponent,
  setIsWhatsApp,
  scrollRef
}) => {
  const [errorCount, setErrorCount] = useState(0);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [textColor, setTextColor] = useState("black");
  const phoneNumberInStore = useSelector(
    (store) => store?.profileDetails?.["phone-number"]
  );
  const [disableButton , setDisableButton] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams()
  

  useEffect(() => {

    if(scrollRef?.current){
      scrollRef?.current?.scrollIntoView({ behavior: 'smooth'})
    }
    return () => {
      if (channel !== undefined && channel != null) {
        channel.unsubscribe();
        client.close();
      }
    };
  }, []);

  function onSubmit(phoneNumber, countryCode) {
    setDisableButton(true);
    dispatch(
      sendVerificationMessage(
        "one_click_verify",
        phoneNumber,
        (successObj) => {
          console.log('gg');
          if (successObj?.result === "success") {
            if (channel !== undefined && channel != null) {
              channel.unsubscribe();
              client.close();
            }
            webSocket();
            setRenderComponent("success");
          } else if (
            successObj?.result === "failed" &&
            successObj?.message === "OTP was not delivered"
          ) {
            setErrorCount((prev) => prev + 1);
          }
          else if(successObj?.result === "error" && successObj?.message === "User Already Verified"){
            dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  phoneNumberInStore , verified : true}});
            dispatch(updateProfileDetails());
            dispatch(checkUserAccess((successObj)=>{ 
              if(successObj?.is_onboarded){
                  if(searchParams.get("course")){
                      navigate(`/popular-course/${searchParams?.get("course")}`);
                    }
                    else{
               navigate('/courses')}
                    }
               else{

                  if(searchParams.get("course")){
                      navigate(`/onboarding/${searchParams?.get("course")}`);
                    }
                    else{
                      navigate('/onboarding')
                    }
             
            }  }))
          }
          else if(successObj?.result === "failed" && successObj?.message === 'Phone already in use')
          {
            toast.error(successObj?.message)
          }
           else {
            setRenderComponent("InValidWhatsApp");
          }
          setDisableButton(false);
        },
        (errorObj) => {
          toast.error(errorObj.message);
          setDisableButton(false);
        }
      )
    );
  }
  function webSocket() {
    client = new Ably.Realtime(API_ABLY_KEY);

    client.connection.on("connected", (stateChange) => {
      console.log("Ably is connected");
      channel = client.channels.get(`verification_${user_id}`);

      channel.subscribe((newMessage) => {
        if (newMessage?.data?.user_id === user_id) {
          dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  selectedCountry?.dial_code + phoneNumber , verified : true}});
          if(searchParams.get("course")){
            navigate(`/onboarding/${searchParams?.get("course")}`);
          }
          else{
            navigate('/onboarding')
          }
        }
        console.log(newMessage);
      });
      setTimeout(() => {
        if (channel !== undefined && channel != null) {
          channel.unsubscribe();
          client.close();
        }
      }, 60000);
    });
  }
  return (
    <>
      <h2 className="mt-3 text-xl font-bold text-white" ref={scrollRef} >
        Mobile Verification
      </h2>
      <h3 className="mt-1 text-sm font-bold text-white/80">
        Verify your number to unlock free access.
      </h3>
      <div className="mt-6 flex w-full flex-col items-center justify-center text-white">
        <div className="flex justify-between w-full">
                <label htmlFor="phone-number" className="ml-1 text-sm">
                  WhatsApp Number*
                </label>
                <div
                  className="text-sm md:text-xs cursor-pointer text-white/80 underline"
                  onClick={(e) => {
                    setRenderComponent("default");
                  }}
                >
                  Edit Number
                </div>
          </div>
        <div className="mb-2 flex w-full flex-col items-center gap-2 md:flex-row md:items-center md:justify-center">
          <div className="w-full md:w-1/3">
            <CountryCode
              selected={selectedCountry}
              setSelected={setSelectedCountry}
              disable={false}
            />
          </div>
          <div className="flex w-full flex-col">
            <div className="flex justify-between">
            </div>
            <input
              id="phone-number"
              name="phone"
              type="tel"
              onChange={(e) => setPhoneNumber(e.target.value)}
              pattern="[0-9.]+"
              required
              disabled={true}
              value={phoneNumber}
              className={`w-full text-white bg-[#223548] appearance-none rounded-md border-gray-400  px-3 py-2   focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 disabled:text-gray-400 sm:text-sm`}
            />
          </div>
        </div>
        <button
          className="mt-4 w-full rounded-lg bg-[#F59E0B] py-2 px-2 text-white disabled:opacity-[0.3]"
          disabled={disableButton}
          onClick={(e) =>
            onSubmit(
              selectedCountry?.dial_code + phoneNumber,
              selectedCountry?.code
            )
          }
        >
          Failed, Click to Retry
        </button>
        {errorCount >= 1 && (
          <div
            className="text-md mt-2 text-[#086788] underline cursor-pointer"
            onClick={(e) => setIsWhatsApp(false)}
          >
            Send OTP via SMS
          </div>
        )}
      </div>
    </>
  );
};

export default TechnicalFailure;
